import React from 'react';
import Header from './ForgotPasswordHeader';
import Form from './ForgotPasswordForm';
import { SWrapper, SForm } from '../styles/Login.styled';
import LoginLayout from '@/presentation/layout/LoginLayout';

const ForgotPassword: React.FC = () => {
  return (
    <LoginLayout>
      <SWrapper>
        <Header />
        <SForm>
          <Form />
        </SForm>
      </SWrapper>
    </LoginLayout>
  );
};

export default ForgotPassword;
